import { isAfter, addHours } from "date-fns";
import { Chip, colors, Grid, Skeleton, Typography } from "@mui/material";

import MDBox from "components/MDBox";

import CardRecGeral from "./CardRecGeral";

import { formatDateEndOfDay } from "helpers/formatDate";
import { IEventoResponse } from "interfaces/eventos";

import { totalsType } from "..";

interface Props {
  evento: IEventoResponse;
  totals: totalsType;
}

export default function RecebimentosPorTipoPay({ evento, totals }: Props) {
  // Caso não exista o evento ou o report, exibe mensagem de carregamento
  if (!evento || !totals) {
    return (
      <MDBox
        color="white"
        bgColor="#344050"
        borderRadius="10px 10px 0 0"
        shadow="lg"
        opacity={1}
        height="100%"
        textAlign="center"
        border="2px solid #ccc"
        overflow="hidden"
        my={2}
      >
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ borderBottom: "1px solid #ccc", padding: 2 }}
        >
          <MDBox display="flex" flexDirection="column" alignItems="flex-start">
            <Typography variant="h5" fontWeight="bold" color={colors.grey[200]}>
              FINANCEIRO
            </Typography>
            <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                variant="h6"
                fontWeight="bold"
                color={colors.grey[200]}
              >
                Periodo iniscrição:
              </Typography>
              <Skeleton animation="wave" width={500} height={40} />
            </MDBox>
          </MDBox>
        </MDBox>

        <MDBox
          sx={{ display: "flex", justifyContent: "space-evenly", gap: 1, p: 2 }}
        >
          <Skeleton animation="pulse" width={150} height={180} />
          <Skeleton animation="pulse" width={150} height={180} />
          <Skeleton animation="pulse" width={150} height={180} />
          <Skeleton animation="pulse" width={150} height={180} />
          <Skeleton animation="pulse" width={150} height={180} />
          <Skeleton animation="pulse" width={150} height={180} />
        </MDBox>
      </MDBox>
    );
  }

  const { inicioIncricao, fimInscricao, status } = evento;

  const isGratuito = evento.formaPaymentoEvento.some(
    (item) => item.TiposPagamento.tipoPagamento === "Gratuito"
  );

  const {
    totalArrecadado,
    totalBoleto,
    totalPix,
    totalCartao,
    totalCortesia,
    totalDesconto,
  } = totals;

  return (
    <MDBox
      color="white"
      bgColor="#344050"
      borderRadius="10px 10px 0 0"
      shadow="lg"
      opacity={1}
      height="100%"
      textAlign="center"
      border="2px solid #ccc"
      overflow="hidden"
      my={2}
    >
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ borderBottom: "1px solid #ccc", padding: 2 }}
      >
        <MDBox display="flex" flexDirection="column" alignItems="flex-start">
          <Typography variant="h5" fontWeight="bold" color={colors.grey[200]}>
            FINANCEIRO
          </Typography>
          <Typography variant="h6" fontWeight="bold" color={colors.grey[200]}>
            Periodo inscrição: {formatDateEndOfDay(inicioIncricao)} à{" "}
            {formatDateEndOfDay(fimInscricao)}
          </Typography>
        </MDBox>

        <MDBox>
          {isGratuito && (
            <Typography
              variant="body1"
              fontWeight="bold"
              color={colors.amber[500]}
            >
              Evento gratuito
            </Typography>
          )}

          <Chip
            label={status.tipo}
            color={status.tipo === "Encerrado" ? "error" : "info"}
            sx={{ px: 1, fontSize: 14 }}
          />
        </MDBox>
      </MDBox>

      <MDBox p={2}>
        <Grid container spacing={2}>
          <CardRecGeral
            title="Total arrecadado"
            valor={totalArrecadado.valor}
            inscritos={totalArrecadado.qtd}
          />
          <CardRecGeral
            title="Boletos"
            valor={totalBoleto.valor}
            inscritos={totalBoleto.qtd}
          />
          <CardRecGeral
            title="Pix"
            valor={totalPix.valor}
            inscritos={totalPix.qtd}
          />
          <CardRecGeral
            title="Cartão de crédito"
            valor={totalCartao.valor}
            inscritos={totalCartao.qtd}
          />
          <CardRecGeral
            title="Cortesia"
            valor={totalCortesia.valor}
            inscritos={totalCortesia.qtd}
          />
          <CardRecGeral
            title="Descontos Cupom"
            valor={totalDesconto.valor}
            inscritos={totalDesconto.qtd}
          />
        </Grid>
      </MDBox>
    </MDBox>
  );
}
